export const localCountryName = 'BR';
